import { useEffect } from 'react';

import { isMobile } from 'react-device-detect';

import {
  AUTH_STORAGE_KEY,
  useAuthenticationMethods,
  useAuthenticationStore,
} from './useAuthentication';

export const useAuthenticationWatcher = () => {
  const setState = useAuthenticationStore(state => state.setState);
  const {init, disconnect} = useAuthenticationMethods();

  useEffect(() => {
    if (isMobile) return;

    const onFocus = async () => {
      const providerType = localStorage.getItem(AUTH_STORAGE_KEY) ?? null;
      const provider = useAuthenticationStore.getState().provider?.type ?? null;

      // if the provider is the same, do nothing
      if (providerType === provider) return;

      await disconnect();

      if (!providerType) return;

      // try to reconnect without changing the state
      localStorage.setItem(AUTH_STORAGE_KEY, providerType);
      setState('none');
      init();
    };

    window.addEventListener('visibilitychange', onFocus);

    return () => {
      window.removeEventListener('visibilitychange', onFocus);
    };
  }, [disconnect, init]);

  // Automatically login if there's an active session already
  useEffect(() => {
    init();
  }, [init]);
};
